<page-title
  text="Corporates | BitOasis"
  i18n-text="@@pageTitle.corporatesPage"
></page-title>

<page-meta
  description="Trusted Crypto platform for corporates"
  i18n-description="@@pageMeta.description.corporatesPage"
>
</page-meta>

<site-layout class="full bg-black" style="overflow-x: hidden">
  <section class="wrapper">
    <div class="group-header">
      <div class="header-content">
        <div class="col col-12 col-md-6 header-col">
          <div>
            <p class="green mb-3" i18n="@@corporates.label">BITOASIS CORPORATE</p>
            <h1 class="title" i18n="@@corporates.title">
              Tailored Crypto Solutions for Your Business
            </h1>
          </div>
          <div class="header-button">
            <h4 class="subtitle" i18n="@@corporates.subtitle">
              Experience secure, efficient, and scalable crypto services with
              BitOasis
            </h4>
            <div class="request-button-wrapper">
              <a
                routerLink="/support/corporateAccount"
                class="btn btn-primary btn-wide"
                i18n="@@corporates.request.enquireNow"
                style="color: black !important"
              >
                Enquire Now
              </a>
            </div>
          </div>

          <div class="header-statistic-wrapper">
            <div class="statistic-box">
              <p i18n="@@corporate.statistics.tradingVolume.label">
                Offering over
              </p>
              <h4 i18n="@@corporate.statistics.tradingVolume.value">
                75+ Tokens
              </h4>
            </div>
            <div class="statistic-box">
              <p i18n="@@corporate.statistics.activeCountries.label">Active in</p>
              <h4 i18n="@@corporate.statistics.activeCountries.value">
                14+ Countries
              </h4>
            </div>
          </div>
        </div>
        <div class="header-image"></div>
      </div>
    </div>
  </section>

  <section class="group-services">
    <div class="service-wrapper">
      <h2 class="title" i18n="@@corporates.services.title">
        Comprehensive Crypto Services for Every Business
      </h2>

      <div class="services-container">
        <div class="services-items-container">
          <div class="service-item-container">
            <div class="service-item-img">
              <img src="assets/images/corporates/new-user.svg" alt="new-user" />
            </div>
            <div class="service-item-text">
              <h4 i18n="@@corporates.services.onboarding.title">
                Seamless Onboarding
              </h4>
              <p i18n="@@corporates.services.onboarding.description">
                Enjoy a smooth, hassle-free, and swift onboarding process.
              </p>
            </div>
          </div>
          <div class="service-item-container">
            <img src="assets/images/corporates/pipes.svg" alt="pipes" />
            <div class="service-item-text">
              <h4 i18n="@@corporates.services.otcTrading.title">
                Over-the-Counter Trading
              </h4>
              <p i18n="@@corporates.services.otcTrading.description">
                Customized solutions for high-volume crypto transactions.
              </p>
            </div>
          </div>
          <div class="service-item-container">
            <img src="assets/images/corporates/handshake.svg" alt="handshake" />
            <div class="service-item-text">
              <h4 i18n="@@corporates.services.accountManagers.title">
                Dedicated Account Managers
              </h4>
              <p i18n="@@corporates.services.accountManagers.description">
                Priority support from our team of seasoned experts.
              </p>
            </div>
          </div>
        </div>
        <div class="service-img"></div>
      </div>
    </div>
  </section>

  <section class="group-dashboard">
    <div class="dashboard-wrapper">
      <h3 class="title" i18n="@@corporates.dashboard.title">
        A Dashboard to Manage Your Crypto
      </h3>

      <div class="dashboard-data-container">
        <div class="dashboard-items-container">
          <div class="dashboard-item-container">
            <h4 i18n="@@corporates.dashboard.tradeOnTheGo.title">
              Trade On-the-Go!
            </h4>
            <p i18n="@@corporates.dashboard.tradeOnTheGo.description">
              Easily place trades and adjust your portfolio on the go, with full
              control at your fingertips.
            </p>
          </div>
          <div class="dashboard-item-container">
            <h4 i18n="@@corporates.dashboard.anytimeAccess.title">
              Anywhere, Anytime Access
            </h4>
            <p i18n="@@corporates.dashboard.anytimeAccess.description">
              Stay connected to your portfolio from any location with our fully
              accessible platform.
            </p>
          </div>
          <div class="dashboard-item-container">
            <h4 i18n="@@corporates.dashboard.customSolutions.title">
              Customized Crypto Solutions
            </h4>
            <p i18n="@@corporates.dashboard.customSolutions.description">
              Our services are tailored to fit the unique requirements of your
              business.
            </p>
          </div>
        </div>

        <div class="dashboard-img"></div>
      </div>
    </div>
  </section>

  <section class="group-why-us">
    <div class="why-us-wrapper">
      <h3 class="title" i18n="@@corporates.whyUs.title">Why Us?</h3>
      <p class="subtitle" i18n="@@corporates.whyUs.subtitle">
        BitOasis is the leading cryptocurrency platform
        <span class="green">in the MENA region</span> trusted by businesses for
        our expertise and reliability.
      </p>
      <div class="why-us-img"></div>

      <div class="why-us-items-container">
        <div class="why-us-item-container">
          <div class="why-us-item-img">
            <img src="assets/images/corporates/secure.svg" alt="secure" />
          </div>
          <h4 i18n="@@corporates.whyUs.security.title">Unmatched Security</h4>
          <p i18n="@@corporates.whyUs.security.description">
            State-of-the-art security measures protect your assets around the
            clock.
          </p>
        </div>

        <div class="why-us-item-container">
          <div class="why-us-item-img">
            <img src="assets/images/corporates/liquid.svg" alt="liquid" />
          </div>
          <h4 i18n="@@corporates.whyUs.liquidity.title">Deep Liquidity</h4>
          <p i18n="@@corporates.whyUs.liquidity.description">
            Access to vast liquidity, ensuring smooth and seamless transactions.
          </p>
        </div>

        <div class="why-us-item-container">
          <div class="why-us-item-img">
            <img src="assets/images/corporates/compliant.svg" alt="compliant" />
          </div>
          <h4 i18n="@@corporates.whyUs.compliance.title">
            Regulatory Compliance
          </h4>
          <p i18n="@@corporates.whyUs.compliance.description">
            Strict adherence to global regulatory standards for your peace of
            mind.
          </p>
        </div>
      </div>

      <div class="companies-container">
        <img src="assets/images/corporates/companies/company-5.svg" alt="company-5" />
        <img src="assets/images/corporates/companies/company-2.svg" alt="company-2" />
        <img src="assets/images/corporates/companies/company-3.svg" alt="company-3" />
        <img src="assets/images/corporates/companies/company-1.svg" alt="company-1" />
        <img src="assets/images/corporates/companies/company-4.svg" alt="company-4" />
      </div>
    </div>
  </section>

  <section class="get-in-touch-container">
    <div class="info-row">
      <h3 class="title" i18n="@@corporates.contact.title">Let's Connect</h3>

      <div class="contact-info-container">
        <div class="contact-info-item">
          <img src="assets/images/corporates/email.svg" alt="email" />
          <p i18n="@@corporates.contact.email">corporate&#64;bitoasis.net</p>
        </div>
      </div>
    </div>

    <div class="enquire-container">
      <h3 i18n="@@corporates.enquire.title">
        Discover Secure, Efficient, and Scalable Crypto Solutions with BitOasis
      </h3>
      <a
        routerLink="/support/corporateAccount"
        class="enquireBtn"
        i18n="@@corporates.enquire.button"
      >
        Enquire now
      </a>

      <img
        class="bitoasis-logo"
        src="assets/images/corporates/vector10.svg"
        alt="BitOasis Logo"
      />
    </div>
  </section>
</site-layout>
<site-footer [displayDisclaimer]="true"></site-footer>
